import {getLocalizationBasedOnLang} from '../../data/models/User/UserInfo';

const english = {
  learnerInviteSuccessMsg: 'Invitation(s) sent successfully',
  learnerInvitePartialSuccessMsg: 'Some of the invitation(s) Sent Successfully',
  learnerInviteFailMsg: 'Invitation(s) not sent',
  inviteLearnersPageTitle: 'Invite learners',
  inviteLearnersPageSubtitle: 'Invite learners to join your workspace.',
  HeadingInviteLearnerInputField: 'Email addresses',
  SubmitButton: 'Send invitations',
  CancelButton: 'Cancel',
  learnerDeleteSuccessMsg: 'Learner deleted successfully',
  learnerActivated: 'Learner activated successfully',
  learnerRemoveFromCourseSuccess: 'Learner removed from the course',
  learnerReEnrollSuccess: 'Learner enrollment activated',
  EmailInstructions:
    'Use the Enter or Return key to add additional email addresses',
  learnerReEnrollFail: 'Failed to enroll learner in the course',
  importFromFile: 'Upload file',
  downloadTemplateOne: 'Download this template',
  downloadTemplateTwo: 'to get started',
  inputPlaceHolder: 'e.g. name@company.com, name2@company.com',
  bulkImportSuccessMsg: 'Learners imported successfully',
  invalidFileFormat: 'Invalid file format. Please upload a CSV or Excel file.',
  emailImport: 'Import learners using comma-separated email addresses.',
  orImportFromFile: 'Import learners from a CSV or Excel file.',
  // Bulk import preview modal
  importPreview: 'Import preview',
  parsingIssues: 'Parsing issues:',
  rowsHaveErrors:
    'Some rows have errors (highlighted in red) and cannot be imported.',
  duplicateEntriesFound: 'Duplicate entries found.',
  selectAll: 'Select all',
  duplicateEmail: 'Duplicate email',
  possibleDuplicate: 'Possible duplicate',
  autoEnrollToCourses: 'Auto-enroll to courses',
  optional: '(optional)',
  selectCourses: 'Select courses',
  importLearners: 'Import',
  learner: 'learner',
  learners: 'learners',
  pleaseWaitProcessing: 'Please wait while we process your request.',
  resendInvitationSuccess: 'Invitation resent successfully',
  resendInvitationFail: 'Failed to resend invitation',
};

const welsh = {
  learnerInviteSuccessMsg: 'Anfonwyd gwahoddiad(au) yn llwyddiannus',
  learnerInvitePartialSuccessMsg:
    "Rhai o'r gwahoddiad(au) a anfonwyd yn llwyddiannus",
  learnerInviteFailMsg: 'Gwahoddiad(au) heb eu hanfon',
  inviteLearnersPageTitle: 'Gwahodd dysgwyr',
  inviteLearnersPageSubtitle:
    'Defnyddiwch y fysell Enter neu Return i ychwanegu cyfeiriadau e-bost ychwanegol',
  HeadingInviteLearnerInputField: 'Gwahodd dysgwyr',
  SubmitButton: 'Cyflwyno',
  CancelButton: 'Canslo',
  learnerDeleteSuccessMsg: "Dysgwr wedi'i dileu'n Llwyddiannus",
  learnerActivated: "Dysgwr wedi'i Ysgogi'n llwyddiannus",
  learnerRemoveFromCourseSuccess: "Dysgwr wedi'i dynnu o'r cwrs",
  learnerReEnrollSuccess: "Ymrestriad dysgwr wedi'i ysgogi",
  EmailInstructions:
    'Defnyddiwch yr allwedd dychwelyd neu nodi i ychwanegu cyfeiriadau e-bost ychwanegol',
  learnerReEnrollFail: 'Wedi methu â chofrestru dysgwr ar y cwrs',
  importFromFile: 'Mewnforio o ffeil',
  downloadTemplate: 'Lawrlwytho templed',
  bulkImportSuccessMsg: "Dysgwyr wedi'u mewnforio'n llwyddiannus",
  invalidFileFormat:
    'Fformat ffeil annilys. Llwythwch ffeil CSV neu Excel os gwelwch yn dda.',
  orImportFromFile: 'Neu mewnforio dysgwyr o ffeil CSV neu Excel',
  // Bulk import preview modal
  importPreview: 'Rhagolwg mewnforio',
  parsingIssues: 'Problemau dosrannu:',
  rowsHaveErrors:
    "Mae gan rai rhesi wallau (wedi'u hamlygu mewn coch) ac ni ellir eu mewnforio.",
  duplicateEntriesFound: 'Canfuwyd cofnodion dyblyg.',
  selectAll: 'Dewis popeth',
  duplicateEmail: 'E-bost dyblyg',
  possibleDuplicate: 'Dyblyg posibl',
  autoEnrollToCourses: "Ymrestru'n awtomatig ar gyrsiau",
  optional: '(dewisol)',
  selectCourses: 'Dewis cyrsiau',
  importLearners: 'Mewnforio',
  learner: 'dysgwr',
  learners: 'dysgwyr',
  pleaseWaitProcessing: 'Arhoswch tra byddwn yn prosesu eich cais.',
  resendInvitationSuccess: "Gwahoddiad wedi'i ailanfon yn llwyddiannus",
  resendInvitationFail: 'Wedi methu ag ailanfon gwahoddiad',
};

export const learnersText: any = getLocalizationBasedOnLang(english, welsh);
